module.exports = __webpack_public_path__ + "images/lynkcoce0a8ae621cc6b191de615eec1980bdb.png";